import { Component, OnInit } from '@angular/core';
import { sessionStorageKey } from '../hayfever.constants';

@Component({
  selector: 'app-hayfever-change-password-sent',
  templateUrl: './hayfever-change-password-sent.component.html',
  styleUrls: [
    '../style/global.css',
    './hayfever-change-password-sent.component.css',
  ],
})
export class HayfeverChangePasswordSentComponent implements OnInit {
  email: string;
  constructor() {
    this.email = sessionStorage.getItem(sessionStorageKey.passwordResetEmail);
    if (!this.email) {
      history.back();
    }
  }

  ngOnInit(): void {}
}
